module.exports = __webpack_public_path__ + "img/distant-view-15.ac8a0f82caf32930578e1f6114ae951b.jpg";